import styled from '@emotion/styled';
import { EmptyClassroom } from '@innovamat/glimmer-assets';
import { Button, Typography } from '@innovamat/glimmer-components';
import { Trans, useTranslation } from 'react-i18next';

const Container = styled.div`
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;

  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;
`;

const Description = styled(Typography.Body1)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  max-width: 800px;
`;

type EmptyStateProps = {
  isJourneyClassroom: boolean;
  isRosteringEnabled: boolean;
  isDisabled?: boolean;
  handleAddStudent: () => void;
};

export function ClassroomStudentsEmptyState({
  isJourneyClassroom,
  isRosteringEnabled,
  isDisabled = false,
  handleAddStudent,
}: EmptyStateProps): JSX.Element {
  const { t } = useTranslation();

  const canAddStudents = isJourneyClassroom || !isRosteringEnabled;

  const renderAddStudentButton = (): JSX.Element | null => {
    if (!canAddStudents) {
      return null;
    }

    return (
      <Button
        rightIcon="AddUpIcon"
        onClick={handleAddStudent}
        disabled={isDisabled}
      >
        {t('students.button.addStudent')}
      </Button>
    );
  };

  const getEmptyStateDescription = (): JSX.Element | string => {
    if (isRosteringEnabled && !isJourneyClassroom) {
      return (
        <Trans
          i18nKey="rostering.action-disabled.message"
          components={{
            b: <b />,
          }}
        />
      );
    }

    return t('students.tableEmptyState.description');
  };

  return (
    <Container>
      <EmptyClassroom />
      <div>
        <Typography.H4>{t('students.tableEmptyState.title')}</Typography.H4>
        <Description>{getEmptyStateDescription()}</Description>
      </div>
      {renderAddStudentButton()}
    </Container>
  );
}
